<template>
  <div class="hotel-selection-layout">
    <div class="upper-panel-wrapper">
      <slot name="upper-panel" />
    </div>
    <div class="lower-panel-wrapper">
      <slot name="lower-panel" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-layout {
  height: 100svh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .upper-panel-wrapper {
    flex-shrink: 0;
    margin-bottom: 0;
  }

  .lower-panel-wrapper {
    flex-grow: 1;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.hotel-selection-layout {
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
}
</style>
